import request from '@/utils/http';

export const getSettleLists = (params) => {
    return request({
        // url: 'http://10.74.134.100:11200/apApply/listApapply',
        url: '/api-bms-web/apApply/listApapply',
        method: 'get',
        params
    });
};

export const getMdnList = (params) => {
    return request({
        url: `/api-mdm/mdmDataDictionaryDetails?dictCode=SRM_BMS_TASK_TYPE`,
        method: 'get',
        params
    });
};